import { useSession } from '@/services/providers/session-provider.tsx';
import { BasicDashboardPage } from '@/pages/dashboard/basic/basic-dashboard.page.tsx';
import { AdvancedDashboardPage } from '@/pages/dashboard/advanced/advanced-dashboard.page';

const Dashboard = () => {
  const { role } = useSession();

  if (role === 'Company owner') return <AdvancedDashboardPage />;
  if (role === 'Company administrator') return <AdvancedDashboardPage />;
  if (role === 'Installer') return <AdvancedDashboardPage />;

  if (role === 'Owner') return <BasicDashboardPage />;
  if (role === 'Guest') return <BasicDashboardPage />;

  return <div></div>;
};

export default Dashboard;
